/* global Sys, Services */
Sys.ns("Services");

Services.Config = {
    constructor: function(configData) {
        Services.Config.superclass.constructor.apply(this, arguments);

        this._config = configData || {};
    },

    /**
     * Provides component configuration.
     *
     * @param {string} component Component name of which config you need (yoda).
     * @returns {Object} Configuration object of component. Null when config of said component is missing.
     */
    getConfig: function(component) {
        return this._config[component] ? this._config[component] : null;
    }
};
Services.Config = Sys.extend(Services.Base, Services.Config, "Services.Config");
